export default {
  filterAnchor: null,
  isBooted: false,
  isLoading: false,
  requestCount: 0,
  s3Url: null,
  schools: [],
  positionsMap: {},
  filterOptions: {},
  preAppliedFilters: {},
  appliedFilters: {},
  openFilter: null,
  activeLocationFilter: 'region',
  isZipCodeValid: false,
  selectedSchool: null,
  showSchoolSearchModal: {name: '', actions: ''},
  needsBySchool: null,
  isApplyingQueryParamFilters: false,
}